<template>
  <div class="user-sidebar">
    <a class="user-sidebar_link" @click="open_user_profile()">
      <span class="user-sidebar_link_ico">
        <i class="mdi mdi-account" />
      </span>
      <b class="user-sidebar_link_name">{{ user.username }} </b>
    </a>
    <a class="user-sidebar_logout" @click="confirm_logout">
      <i class="mdi mdi-logout" />
    </a>
  </div>
</template>
<script>

import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm";
import ShowUser from "components/UIComponents/Plugins/SidebarPlugin/User/ShowUser.vue";

export default {
  props: {
  },
  computed:{
    user(){
      return this.$store.getters.getUser
    }
  },
  methods: {
    confirm_logout () {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('user.logout_question')
        },
        on: {
          close: () => {
            this.$modal.hide('logout_modal')
          },
          confirm: () => {
            this.logout()
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'logout_modal'})

    },
    logout () {
      this.$http.v1.logoutUser(() => {
        this.localStorage.removeItem('auth')
        this.localStorage.removeItem('filter_devices')
        this.localStorage.removeItem('filter_esim_profile')
        this.localStorage.removeItem('filter_simcard_devices')
        this.localStorage.removeItem('filter_simcard_profile')

        this.$store.commit('updateAuth', false)

        this.localStorage.setItem('logout', 1)
        this.localStorage.setItem('path', '')

        this.$store.commit('logout')
        this.$store.commit('clearDevice')
        this.$store.commit('clearSimcardProfile')
        this.$store.commit('clearSimcardDevices')
      })
    },

    open_user_profile(){

      var t = this.$createElement(ShowUser, {
        props: {
          user: this.user,
        },
        on: {
          close: () => {
            this.$modal.hide('user_profile_modal')
            this.check_link = true
          },
          update: () => { this.getUsers() }
        }
      })
      let temp = {render () { return t }}
      this.$modal.show(temp, {}, {
        height: 800,
        width: 800,
        adaptive: true,
        clickToClose: true,
        name: 'user_profile_modal'
      })
    }
  }
}

</script>

<style lang="scss">
  .user-sidebar {
    padding: 13px 0;
    margin: 0 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    position: relative;
  }
  .user-sidebar_link {
    font: 600 12px/2rem "Roboto", Arial, sans-serif;
    vertical-align: middle;
    text-transform: uppercase;
    text-decoration: none !important;
    color: #fff !important;
    cursor: pointer;
  }
  .user-sidebar_link_ico {
    display: inline-block;
    vertical-align: middle;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    margin: -2px 4px -2px 0;
    text-align: center;
  }
  .user-sidebar_link_ico > img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    vertical-align: middle;
  }
  .user-sidebar_link_ico > i {
    font-size: 18px;
    margin: 0 0 -1px -1px;
    line-height: 2rem;
    display: inline-block;
    vertical-align: bottom;
    color: #41B883;
  }
  .user-sidebar_link_name {
    font: normal 16px/2rem "Roboto", Arial, sans-serif;
    vertical-align: middle;
    text-transform: none;
    white-space: nowrap;
    max-width: calc(100% - 2.5rem);
    overflow: hidden;
  }
  .user-sidebar_logout {
    vertical-align: middle;
    text-decoration: none;
    color: #FFC0A4 !important;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 15px;
    max-height: 20px;
    max-width: 20px;
    overflow: hidden;
  }
  .user-sidebar_logout > i {
    display: inline-block;
    font: 600 18px/2rem "Roboto", Arial, sans-serif;
    margin: 0 0 -2px;
  }
   //cтили колокольчика
  /* .user-sidebar_bell {
    vertical-align: middle;
    text-decoration: none;
    color: #F5DEB3!important;
    cursor: pointer;
    position: absolute;
    right: 25px;
    top: 15px;
    max-height: 20px;
    max-width: 20px;
    overflow: hidden; */
 /*  }
  .user-sidebar_bell > i {
    display: inline-block;
    font: 600 18px/2rem "Roboto", Arial, sans-serif;
    margin: 0 0 -15px;
  } */
</style>
